import { FC, Fragment, useEffect } from 'react';
import { WithChildren } from '../../types/utility';
import { CALLBACK_EVENTS, CallbackEvent, Callbacks } from '../../types/sdk';
import { callbackRegistry } from '../../features/session/callback-registry';

type Props = WithChildren<{ callbacks: Callbacks | undefined }>;

export const CallbackContextProvider: FC<Props> = ({ children, callbacks }) => {
	useEffect(() => {
		initializeCallbacks(callbacks);
	}, [callbacks]);

	return <Fragment>{children}</Fragment>;
};

const initializeCallbacks = (callbacks: Callbacks | undefined) => {
	if (callbacks) {
		for (const [event, callback] of Object.entries(callbacks)) {
			if (isCallbackEvent(event)) callbackRegistry.register(event, callback);
		}
	}
};

const isCallbackEvent = (event: string): event is CallbackEvent => {
	return CALLBACK_EVENTS.includes(event);
};
